import { Component } from '@angular/core';

import { TableCellBaseComponent } from '@wcg/frontend-framework';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'wcg-document-qc-status-cell',
    imports: [MatIconModule],
    templateUrl: './document-qc-status-cell.component.html',
    styleUrls: ['./document-qc-status-cell.component.scss']
})
export class DocumentQcStatusCellComponent extends TableCellBaseComponent<any> {}
